import { render } from "./SectionOBForm.vue?vue&type=template&id=30be5544&scoped=true"
import script from "./SectionOBForm.vue?vue&type=script&lang=js"
export * from "./SectionOBForm.vue?vue&type=script&lang=js"

import "./SectionOBForm.vue?vue&type=style&index=0&id=30be5544&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30be5544"]])

export default __exports__